module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABGdBTUEAALGPC/xhBQAAAIdJREFUWAnt0jEKgDAQRNG4IngDEcSL6PH1IhIQbyCI0TZFMMUUKvxUIezA8jLOcRBA4N8CRW79fe2u3ExpNlbNMsdzx9YPZwhT/Ja6161/3MFSoS+9saD6GwgiqAqoeTqIoCqg5ukggqqAmqeDCKoCap4OIqgKqHk6iKAqoObpoCpIHoG3BW7cwQw856vcyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pause.png
// module id = GkM+
// module chunks = 0